<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
export default
{
    mixins: [ adminTable ],

    mounted()
    {
        this.$store.dispatch('artistCheck')
    },

    data()
    {
        return {
            data: [],
            url: '/v1/admin/programcategories',
            tableName: 'tableProgramcategories',
            emptyModel: { name: null, color: null, programs: [] },
            columns: [ 'id', 'name', 'color', 'created_at', 'updated_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    name: this.$t('WISHLIST.NAME'),
                    color: this.$t('GENERAL.COLOR'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'created_at', 'updated_at'],
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('WISHLIST.CATEGORY') }}</span>
            <mv-program-category-form :model="model" :edit="formEdit" @save="saveForm().then(() => $store.dispatch('programcatFetch'))"></mv-program-category-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm().then(() => $store.dispatch('programcatFetch'))">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('WISHLIST.WISHLIST') }} {{ $t('WISHLIST.CATEGORIES') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="picture" slot-scope="props">
                        <div v-if="props.row.attachments && props.row.attachments.length > 0">
                            <img :src="props.row.attachments[0].thumbnail_url">
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/pages/ProgramCategories.vue